import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';

export const useSeriesNav = () => {
  const { currentUser } = useCurrentUserContext();

  const {
    flags: { enableSeriesOnboardingPacks = false },
  } = useFeatureFlags();
  return (
    enableSeriesOnboardingPacks &&
    !currentUser?.anyUserSportProfile?.proUnlocked
  );
};
